export default __webpack_public_path__ + "static/miceBanner2_2560-12ea1c9c58d7f2de5738a239606b776d.jpg";